// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-v"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 5L16 14.2732C16 14.5047 15.9196 14.7291 15.7727 14.908L12 19.5L8.22733 14.908C8.08035 14.7291 8 14.5047 8 14.2732L8.00001 5","strokeLinecap":"square","strokeLinejoin":"bevel","strokeWidth":"props.strokeWidth"}}]}]};

const LettersVIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-v',
    ref,
    icon: element,
  },
));

LettersVIcon.displayName = 'LettersVIcon';

export default LettersVIcon;
